import { render, staticRenderFns } from "./ProductSku.vue?vue&type=template&id=42a63271&scoped=true&"
import script from "./ProductSku.vue?vue&type=script&lang=js&"
export * from "./ProductSku.vue?vue&type=script&lang=js&"
import style0 from "./ProductSku.vue?vue&type=style&index=0&id=42a63271&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a63271",
  null
  
)

export default component.exports